import React from "react";
import { Zap } from "lucide-react";

// Small cost badge shown next to paid-action buttons, e.g. ⚡ 0.5 cr / ⚡ Free
export const CreditPill = ({ cost, free = false, className = "" }) => {
  const isFree = free || Number(cost) === 0;
  const label = isFree ? "Free" : `${Number(cost) % 1 === 0 ? Number(cost) : Number(cost).toFixed(2)} cr`;
  return (
    <span
      data-testid="credit-pill"
      className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-medium leading-none whitespace-nowrap ${
        isFree ? "bg-green-500/15 text-green-400" : "bg-brand/15 text-brand"
      } ${className}`}
    >
      <Zap size={11} className="shrink-0" />
      {label}
    </span>
  );
};

export default CreditPill;
